module.exports = __webpack_public_path__ + "static/media/icon-file.5bd43cb8.svg";